import * as THREE from "three";
import { MeshConfig, HighLevelJoint } from "types/stl";

export const P0: HighLevelJoint = {
  vertices: [
    {
      ids: [
        538,
        541,
      ],
      weight: 0.75
    },
  ],
  centerId: 541,
  name: "P0",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P1: HighLevelJoint = {
  vertices: [
    {
      ids: [
        490,
        491,
      ],
      weight: 0.75
    },
  ],
  centerId: 490,
  name: "P1",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P2: HighLevelJoint = {
  vertices: [
    {
      ids: [
        489,
        492,
      ],
      weight: 1
    },
  ],
  centerId: 489,
  name: "P2",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P3: HighLevelJoint = {
  vertices: [
    {
      ids: [
        530,
        531,
      ],
      weight: 1
    },
  ],
  centerId: 530,
  name: "P3",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P4: HighLevelJoint = {
  vertices: [
    {
      ids: [
        529,
        532,
      ],
      weight: 1
    },
  ],
  centerId: 529,
  name: "P4",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P5: HighLevelJoint = {
  vertices: [
    {
      ids: [
        533,
        581,
      ],
      weight: 1
    },
  ],
  centerId: 533,
  name: "P5",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P6: HighLevelJoint = {
  vertices: [
    {
      ids: [
        536,
        580,
      ],
      weight: 1
    },
  ],
  centerId: 536,
  name: "P6",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P7: HighLevelJoint = {
  vertices: [
    {
      ids: [
        505,
        506,
      ],
      weight: 1
    },
  ],
  centerId: 505,
  name: "P7",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P8: HighLevelJoint = {
  vertices: [
    {
      ids: [
        504,
        507,
      ],
      weight: 1
    },
  ],
  centerId: 504,
  name: "P8",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P9: HighLevelJoint = {
  vertices: [
    {
      ids: [
        535,
        576,
      ],
      weight: 1
    },
  ],
  centerId: 576,
  name: "P9",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P10: HighLevelJoint = {
  vertices: [
    {
      ids: [
        534,
        582,
      ],
      weight: 1
    },
  ],
  centerId: 534,
  name: "P10",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P11: HighLevelJoint = {
  vertices: [
    {
      ids: [
        509,
        510,
      ],
      weight: 1
    },
  ],
  centerId: 509,
  name: "P11",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P12: HighLevelJoint = {
  vertices: [
    {
      ids: [
        508,
        511,
      ],
      weight: 1
    },
  ],
  centerId: 508,
  name: "P12",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P13: HighLevelJoint = {
  vertices: [
    {
      ids: [
        497,
        520,
      ],
      weight: 1
    },
    {
      ids: [
        498,
      ],
      weight: 0.35
    },
  ],
  centerId: 497,
  name: "P13",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P14: HighLevelJoint = {
  vertices: [
    {
      ids: [
        486,
        487,
      ],
      weight: 1
    },
    {
      ids: [
        499,
      ],
      weight: 0.35
    },
  ],
  centerId: 486,
  name: "P14",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P15: HighLevelJoint = {
  vertices: [
    {
      ids: [
        485,
        488,
      ],
      weight: 1
    },
    {
      ids: [
        564,
      ],
      weight: 0.35
    },
  ],
  centerId: 485,
  name: "P15",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P16: HighLevelJoint = {
  vertices: [
    {
      ids: [
        551,
        552,
      ],
      weight: 1
    },
    {
      ids: [
        565,
      ],
      weight: 0.35
    },
  ],
  centerId: 551,
  name: "P16",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P17: HighLevelJoint = {
  vertices: [
    {
      ids: [
        566,
        567,
      ],
      weight: 1
    },
    {
      ids: [
        568,
      ],
      weight: 0.35
    },
  ],
  centerId: 566,
  name: "P17",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P18: HighLevelJoint = {
  vertices: [
    {
      ids: [
        569,
        585,
      ],
      weight: 1
    },
    {
      ids: [
        548,
      ],
      weight: 0.35
    },
  ],
  centerId: 569,
  name: "P18",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P19: HighLevelJoint = {
  vertices: [
    {
      ids: [
        570,
        584,
      ],
      weight: 1
    },
    {
      ids: [
        550,
      ],
      weight: 0.35
    },
  ],
  centerId: 570,
  name: "P19",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P20: HighLevelJoint = {
  vertices: [
    {
      ids: [
        575,
        583,
      ],
      weight: 1
    },
    {
      ids: [
        554,
      ],
      weight: 0.35
    },
  ],
  centerId: 575,
  name: "P20",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P21: HighLevelJoint = {
  vertices: [
    {
      ids: [
        545,
        546,
      ],
      weight: 1
    },
    {
      ids: [
        574,
      ],
      weight: 0.35
    },
  ],
  centerId: 545,
  name: "P21",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P22: HighLevelJoint = {
  vertices: [
    {
      ids: [
        544,
        547,
      ],
      weight: 1
    },
    {
      ids: [
        558,
      ],
      weight: 0.35
    },
  ],
  centerId: 544,
  name: "P22",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P23: HighLevelJoint = {
  vertices: [
    {
      ids: [
        563,
        573,
      ],
      weight: 1
    },
    {
      ids: [
        557,
      ],
      weight: 0.35
    },
  ],
  centerId: 573,
  name: "P23",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P24: HighLevelJoint = {
  vertices: [
    {
      ids: [
        562,
        579,
      ],
      weight: 1
    },
    {
      ids: [
        561,
      ],
      weight: 0.35
    },
  ],
  centerId: 562,
  name: "P24",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P25: HighLevelJoint = {
  vertices: [
    {
      ids: [
        517,
        518,
      ],
      weight: 1
    },
    {
      ids: [
        556,
      ],
      weight: 0.35
    },
  ],
  centerId: 517,
  name: "P25",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P26: HighLevelJoint = {
  vertices: [
    {
      ids: [
        516,
        519,
      ],
      weight: 1
    },
  ],
  centerId: 516,
  name: "P26",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P27: HighLevelJoint = {
  vertices: [
    {
      ids: [
        522,
        523,
      ],
      weight: 1
    },
  ],
  centerId: 522,
  name: "P27",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P28: HighLevelJoint = {
  vertices: [
    {
      ids: [
        521,
        524,
      ],
      weight: 1
    },
  ],
  centerId: 521,
  name: "P28",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P29: HighLevelJoint = {
  vertices: [
    {
      ids: [
        494,
        495,
      ],
      weight: 1
    },
  ],
  centerId: 494,
  name: "P29",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P30: HighLevelJoint = {
  vertices: [
    {
      ids: [
        493,
        496,
      ],
      weight: 1
    },
  ],
  centerId: 493,
  name: "P30",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const P31: HighLevelJoint = {
  vertices: [
    {
      ids: [
        539,
        542,
      ],
      weight: 1
    },
  ],
  centerId: 542,
  name: "P31",
  min: -10,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const heelDepthJoint: HighLevelJoint = {
  vertices: [
    {
      ids: [
        6,
        149,
        150,
        213,
        214,
        260,
        261,
        291,
        465,
        485,
        486,
        488,
        497,
        520,
        551,
        552,
        566,
        567,
        569,
        570,
        584,
        585,
      ],
      weight: 1
    },
    {
      ids: [
        259,
        487,
      ],
      weight: 0.99
    },
    {
      ids: [
        242,
      ],
      weight: 0.98
    },
    {
      ids: [
        262,
      ],
      weight: 0.97
    },
    {
      ids: [
        215,
        464,
      ],
      weight: 0.96
    },
    {
      ids: [
        4,
        239,
      ],
      weight: 0.94
    },
    {
      ids: [
        292,
      ],
      weight: 0.93
    },
    {
      ids: [
        148,
        216,
      ],
      weight: 0.91
    },
    {
      ids: [
        240,
        243,
      ],
      weight: 0.9
    },
    {
      ids: [
        469,
      ],
      weight: 0.88
    },
    {
      ids: [
        217,
      ],
      weight: 0.87
    },
    {
      ids: [
        474,
      ],
      weight: 0.84
    },
    {
      ids: [
        219,
        435,
      ],
      weight: 0.79
    },
    {
      ids: [
        218,
      ],
      weight: 0.77
    },
    {
      ids: [
        5,
        436,
      ],
      weight: 0.76
    },
    {
      ids: [
        224,
        225,
      ],
      weight: 0.73
    },
    {
      ids: [
        226,
      ],
      weight: 0.71
    },
    {
      ids: [
        484,
      ],
      weight: 0.69
    },
    {
      ids: [
        358,
      ],
      weight: 0.68
    },
    {
      ids: [
        508,
        511,
        583,
      ],
      weight: 0.67
    },
    {
      ids: [
        341,
        575,
      ],
      weight: 0.66
    },
    {
      ids: [
        195,
      ],
      weight: 0.65
    },
    {
      ids: [
        470,
      ],
      weight: 0.63
    },
    {
      ids: [
        345,
        418,
        434,
      ],
      weight: 0.6
    },
    {
      ids: [
        193,
      ],
      weight: 0.58
    },
    {
      ids: [
        342,
        483,
      ],
      weight: 0.57
    },
    {
      ids: [
        473,
      ],
      weight: 0.54
    },
    {
      ids: [
        238,
      ],
      weight: 0.45
    },
    {
      ids: [
        221,
      ],
      weight: 0.44
    },
    {
      ids: [
        498,
        548,
        550,
      ],
      weight: 0.35
    },
    {
      ids: [
        499,
        564,
        568,
      ],
      weight: 0.34
    },
    {
      ids: [
        222,
        223,
        565,
      ],
      weight: 0.33
    },
    {
      ids: [
        433,
        439,
      ],
      weight: 0.3
    },
    {
      ids: [
        227,
      ],
      weight: 0.29
    },
    {
      ids: [
        344,
      ],
      weight: 0.24
    },
  ],
  centerId: 549,
  name: "Heel Depth",
  min: 1,
  max: 40,
  value: 5,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const heelHeightJoint: HighLevelJoint = {
  vertices: [
    {
      ids: [
        215,
        292,
        485,
        486,
        487,
        488,
        497,
        498,
        499,
        520,
        548,
        549,
        550,
        551,
        552,
        564,
        565,
        566,
        567,
        568,
        569,
        570,
        584,
        585,
      ],
      weight: 1
    },
    {
      ids: [
        148,
      ],
      weight: 0.96
    },
    {
      ids: [
        150,
      ],
      weight: 0.94
    },
    {
      ids: [
        259,
      ],
      weight: 0.93
    },
    {
      ids: [
        291,
      ],
      weight: 0.92
    },
    {
      ids: [
        149,
        214,
        262,
      ],
      weight: 0.88
    },
    {
      ids: [
        436,
      ],
      weight: 0.87
    },
    {
      ids: [
        554,
      ],
      weight: 0.85
    },
    {
      ids: [
        508,
        511,
        543,
        553,
        575,
        583,
      ],
      weight: 0.84
    },
    {
      ids: [
        435,
      ],
      weight: 0.83
    },
    {
      ids: [
        240,
      ],
      weight: 0.79
    },
    {
      ids: [
        484,
      ],
      weight: 0.74
    },
    {
      ids: [
        213,
        239,
      ],
      weight: 0.72
    },
    {
      ids: [
        509,
        510,
        545,
        546,
      ],
      weight: 0.69
    },
    {
      ids: [
        571,
        572,
        574,
      ],
      weight: 0.68
    },
    {
      ids: [
        216,
        465,
      ],
      weight: 0.67
    },
    {
      ids: [
        434,
      ],
      weight: 0.65
    },
    {
      ids: [
        260,
        261,
      ],
      weight: 0.61
    },
    {
      ids: [
        219,
        226,
      ],
      weight: 0.6
    },
    {
      ids: [
        4,
      ],
      weight: 0.59
    },
    {
      ids: [
        6,
      ],
      weight: 0.58
    },
    {
      ids: [
        225,
        464,
      ],
      weight: 0.57
    },
    {
      ids: [
        512,
        515,
        534,
        544,
        547,
        558,
        582,
      ],
      weight: 0.53
    },
    {
      ids: [
        227,
        433,
      ],
      weight: 0.5
    },
    {
      ids: [
        439,
      ],
      weight: 0.49
    },
    {
      ids: [
        242,
      ],
      weight: 0.44
    },
    {
      ids: [
        224,
      ],
      weight: 0.42
    },
    {
      ids: [
        5,
        217,
        222,
      ],
      weight: 0.38
    },
    {
      ids: [
        438,
        513,
        514,
        535,
        557,
        563,
        573,
        576,
      ],
      weight: 0.37
    },
    {
      ids: [
        238,
        469,
      ],
      weight: 0.35
    },
    {
      ids: [
        218,
      ],
      weight: 0.34
    },
    {
      ids: [
        474,
      ],
      weight: 0.33
    },
    {
      ids: [
        243,
        432,
      ],
      weight: 0.31
    },
    {
      ids: [
        296,
      ],
      weight: 0.29
    },
    {
      ids: [
        437,
      ],
      weight: 0.27
    },
    {
      ids: [
        358,
      ],
      weight: 0.26
    },
    {
      ids: [
        223,
        278,
      ],
      weight: 0.25
    },
    {
      ids: [
        441,
      ],
      weight: 0.24
    },
    {
      ids: [
        160,
        267,
        341,
        561,
      ],
      weight: 0.22
    },
    {
      ids: [
        504,
        507,
        562,
        577,
        578,
        579,
      ],
      weight: 0.21
    },
    {
      ids: [
        195,
        221,
      ],
      weight: 0.2
    },
    {
      ids: [
        266,
        277,
        431,
        470,
        473,
      ],
      weight: 0.18
    },
    {
      ids: [
        299,
        345,
      ],
      weight: 0.17
    },
    {
      ids: [
        275,
        418,
      ],
      weight: 0.15
    },
    {
      ids: [
        342,
        430,
        442,
      ],
      weight: 0.14
    },
    {
      ids: [
        193,
        272,
        298,
        309,
        440,
      ],
      weight: 0.13
    },
    {
      ids: [
        483,
      ],
      weight: 0.12
    },
    {
      ids: [
        157,
        316,
      ],
      weight: 0.11
    },
    {
      ids: [
        268,
        276,
      ],
      weight: 0.1
    },
    {
      ids: [
        429,
        481,
      ],
      weight: 0.09
    },
    {
      ids: [
        297,
        304,
        344,
        380,
      ],
      weight: 0.08
    }
  ],
  centerId: 549,
  name: "Heel Height",
  min: 0,
  max: 40,
  value: 4,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const heelLateralJoint: HighLevelJoint = {
  vertices: [
    {
      ids: [
        497,
        520,
      ],
      weight: 1
    },
    {
      ids: [
        486,
      ],
      weight: 0.83
    },
    {
      ids: [
        487,
      ],
      weight: 0.81
    },
    {
      ids: [
        508,
        511,
      ],
      weight: 0.74
    },
    {
      ids: [
        485,
        488,
      ],
      weight: 0.56
    },
    {
      ids: [
        498,
      ],
      weight: 0.5
    },
    {
      ids: [
        499,
      ],
      weight: 0.4
    },
    {
      ids: [
        543,
      ],
      weight: 0.37
    },
    {
      ids: [
        509,
        510,
      ],
      weight: 0.35
    },
    {
      ids: [
        564,
      ],
      weight: 0.22
    },
    {
      ids: [
        571,
      ],
      weight: 0.2
    },
    {
      ids: [
        512,
        534,
        582,
      ],
      weight: 0.14
    },
    {
      ids: [
        552,
      ],
      weight: 0.01
    },
    {
      ids: [
        549,
        565,
      ],
      weight: 0
    },
  ],
  centerId: 497,
  name: "Heel Lateral Wedge",
  min: 0,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const heelMedialJoint: HighLevelJoint = {
  vertices: [
    {
      ids: [
        570,
        584,
      ],
      weight: 1
    },
    {
      ids: [
        569,
        585,
      ],
      weight: 0.83
    },
    {
      ids: [
        583,
      ],
      weight: 0.74
    },
    {
      ids: [
        575,
      ],
      weight: 0.72
    },
    {
      ids: [
        566,
        567,
      ],
      weight: 0.55
    },
    {
      ids: [
        548,
        550,
      ],
      weight: 0.5
    },
    {
      ids: [
        554,
      ],
      weight: 0.36
    },
    {
      ids: [
        545,
        546,
      ],
      weight: 0.35
    },
    {
      ids: [
        568,
      ],
      weight: 0.23
    },
    {
      ids: [
        574,
      ],
      weight: 0.2
    },
    {
      ids: [
        544,
        547,
        558,
      ],
      weight: 0.14
    },
    {
      ids: [
        572,
      ],
      weight: 0
    },
  ],
  centerId: 570,
  name: "Heel Medial Wedge",
  min: 0,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const archLateralJoint: HighLevelJoint = {
  vertices: [
    {
      ids: [
        438,
        535,
        576,
      ],
      weight: 0.96
    },
    {
      ids: [
        441,
        534,
        582,
      ],
      weight: 0.93
    },
    {
      ids: [
        440,
      ],
      weight: 0.9
    },
    {
      ids: [
        437,
      ],
      weight: 0.89
    },
    {
      ids: [
        272,
      ],
      weight: 0.85
    },
    {
      ids: [
        220,
      ],
      weight: 0.81
    },
    {
      ids: [
        439,
      ],
      weight: 0.74
    },
    {
      ids: [
        303,
        442,
      ],
      weight: 0.72
    },
    {
      ids: [
        256,
      ],
      weight: 0.71
    },
    {
      ids: [
        238,
      ],
      weight: 0.67
    },
    {
      ids: [
        221,
        290,
      ],
      weight: 0.61
    },
    {
      ids: [
        509,
        510,
      ],
      weight: 0.6
    },
    {
      ids: [
        206,
      ],
      weight: 0.59
    },
    {
      ids: [
        245,
      ],
      weight: 0.57
    },
    {
      ids: [
        244,
        255,
      ],
      weight: 0.56
    },
    {
      ids: [
        257,
      ],
      weight: 0.54
    },
    {
      ids: [
        301,
      ],
      weight: 0.52
    },
    {
      ids: [
        302,
        504,
        507,
      ],
      weight: 0.5
    },
    {
      ids: [
        443,
      ],
      weight: 0.49
    },
    {
      ids: [
        258,
        332,
      ],
      weight: 0.48
    },
    {
      ids: [
        389,
        390,
      ],
      weight: 0.47
    },
    {
      ids: [
        263,
        393,
      ],
      weight: 0.45
    },
    {
      ids: [
        246,
      ],
      weight: 0.44
    },
    {
      ids: [
        306,
        408,
      ],
      weight: 0.42
    },
    {
      ids: [
        264,
        265,
        308,
        415,
      ],
      weight: 0.41
    },
    {
      ids: [
        405,
        412,
        484,
      ],
      weight: 0.4
    },
    {
      ids: [
        400,
      ],
      weight: 0.39
    },
    {
      ids: [
        253,
        280,
        281,
        282,
        283,
        284,
        285,
        286,
        294,
        295,
        307,
        362,
        363,
        364,
        365,
        366,
        369,
        373,
        374,
        375,
        376,
        391,
        392,
        406,
        407,
        411,
      ],
      weight: 0.38
    },
    {
      ids: [
        254,
        311,
        324,
        409,
        410,
      ],
      weight: 0.37
    },
    {
      ids: [
        212,
        252,
        312,
        388,
        395,
      ],
      weight: 0.36
    },
    {
      ids: [
        325,
        397,
        425,
      ],
      weight: 0.35
    },
    {
      ids: [
        171,
        205,
        219,
        401,
      ],
      weight: 0.34
    },
    {
      ids: [
        287,
        329,
        396,
        398,
      ],
      weight: 0.33
    },
    {
      ids: [
        202,
        424,
      ],
      weight: 0.32
    },
    {
      ids: [
        328,
      ],
      weight: 0.31
    },
    {
      ids: [
        211,
        218,
        247,
        293,
        444,
      ],
      weight: 0.3
    },
    {
      ids: [
        269,
      ],
      weight: 0.29
    },
    {
      ids: [
        399,
      ],
      weight: 0.24
    },
    {
      ids: [
        436,
      ],
      weight: 0.23
    },
    {
      ids: [
        216,
      ],
      weight: 0.22
    },
    {
      ids: [
        512,
      ],
      weight: 0.21
    },
    {
      ids: [
        513,
        571,
      ],
      weight: 0.2
    },
    {
      ids: [
        327,
      ],
      weight: 0.19
    },
    {
      ids: [
        170,
        367,
      ],
      weight: 0.18
    },
    {
      ids: [
        326,
        445,
      ],
      weight: 0.17
    },
    {
      ids: [
        89,
        313,
        577,
      ],
      weight: 0.16
    },
    {
      ids: [
        210,
        368,
        394,
      ],
      weight: 0.14
    },
    {
      ids: [
        88,
        203,
        204,
        310,
        322,
        372,
        378,
        380,
        381,
      ],
      weight: 0.13
    },
    {
      ids: [
        402,
      ],
      weight: 0.12
    },
    {
      ids: [
        314,
        318,
      ],
      weight: 0.1
    },
    {
      ids: [
        403,
      ],
      weight: 0.09
    },
    {
      ids: [
        379,
        508,
        511,
      ],
      weight: 0.07
    },
    {
      ids: [
        160,
      ],
      weight: 0.06
    },
    {
      ids: [
        321,
        386,
      ],
      weight: 0.05
    },
    {
      ids: [
        226,
        316,
        371,
        500,
        505,
        506,
      ],
      weight: 0.04
    },
    {
      ids: [
        298,
        299,
        304,
        416,
        543,
      ],
      weight: 0.03
    },
    {
      ids: [
        47,
        50,
        222,
        278,
        296,
        297,
        319,
        331,
        370,
        387,
        417,
        446,
      ],
      weight: 0.02
    },
    {
      ids: [
        87,
        158,
        225,
        227,
        266,
        275,
        305,
        377,
        384,
        404,
        447,
        457,
        503,
      ],
      weight: 0.01
    },
    {
      ids: [
        145,
        159,
        223,
        224,
        267,
        268,
        270,
        271,
        276,
        277,
        279,
        288,
        289,
        300,
        317,
        330,
        383,
        385,
        456,
        502,
        578,
      ],
      weight: 0
    },
  ],
  centerId: 535,
  name: "Arch Lateral Height",
  min: 1,
  max: 40,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const archCenterJoint: HighLevelJoint = {
  vertices: [
    {
      ids: [
        514,
        515,
        578,
      ],
      weight: 1
    },
    {
      ids: [
        512,
        513,
        557,
        561,
      ],
      weight: 0.85
    },
    {
      ids: [
        503,
        556,
        558,
        571,
        572,
        577,
      ],
      weight: 0.7
    },
    {
      ids: [
        500,
        574,
      ],
      weight: 0.5
    },
    {
      ids: [
        507,
        535,
        547,
        563,
      ],
      weight: 0.01
    },
  ],
  centerId: 514,
  name: "Arch Center Height",
  min: 1,
  max: 40,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const archMedialJoint: HighLevelJoint = {
  vertices: [
    {
      ids: [
        563,
        573,
      ],
      weight: 0.96
    },
    {
      ids: [
        544,
        547,
      ],
      weight: 0.93
    },
    {
      ids: [
        431,
        432,
      ],
      weight: 0.92
    },
    {
      ids: [
        222,
      ],
      weight: 0.9
    },
    {
      ids: [
        296,
      ],
      weight: 0.88
    },
    {
      ids: [
        227,
      ],
      weight: 0.87
    },
    {
      ids: [
        433,
      ],
      weight: 0.86
    },
    {
      ids: [
        223,
      ],
      weight: 0.84
    },
    {
      ids: [
        299,
        430,
      ],
      weight: 0.83
    },
    {
      ids: [
        278,
      ],
      weight: 0.82
    },
    {
      ids: [
        267,
      ],
      weight: 0.79
    },
    {
      ids: [
        277,
      ],
      weight: 0.78
    },
    {
      ids: [
        226,
        275,
      ],
      weight: 0.75
    },
    {
      ids: [
        266,
      ],
      weight: 0.74
    },
    {
      ids: [
        309,
      ],
      weight: 0.73
    },
    {
      ids: [
        434,
      ],
      weight: 0.72
    },
    {
      ids: [
        157,
      ],
      weight: 0.7
    },
    {
      ids: [
        224,
      ],
      weight: 0.69
    },
    {
      ids: [
        268,
        276,
        298,
      ],
      weight: 0.68
    },
    {
      ids: [
        225,
        316,
      ],
      weight: 0.67
    },
    {
      ids: [
        304,
      ],
      weight: 0.63
    },
    {
      ids: [
        297,
        429,
      ],
      weight: 0.62
    },
    {
      ids: [
        545,
        546,
      ],
      weight: 0.6
    },
    {
      ids: [
        240,
      ],
      weight: 0.59
    },
    {
      ids: [
        239,
        317,
      ],
      weight: 0.58
    },
    {
      ids: [
        380,
      ],
      weight: 0.56
    },
    {
      ids: [
        270,
        435,
      ],
      weight: 0.55
    },
    {
      ids: [
        394,
      ],
      weight: 0.54
    },
    {
      ids: [
        158,
        333,
        382,
        562,
        579,
      ],
      weight: 0.53
    },
    {
      ids: [
        305,
      ],
      weight: 0.51
    },
    {
      ids: [
        288,
      ],
      weight: 0.49
    },
    {
      ids: [
        4,
        379,
        381,
      ],
      weight: 0.47
    },
    {
      ids: [
        367,
      ],
      weight: 0.46
    },
    {
      ids: [
        331,
      ],
      weight: 0.43
    },
    {
      ids: [
        271,
        376,
      ],
      weight: 0.4
    },
    {
      ids: [
        371,
        375,
      ],
      weight: 0.39
    },
    {
      ids: [
        289,
        383,
      ],
      weight: 0.38
    },
    {
      ids: [
        368,
        378,
      ],
      weight: 0.37
    },
    {
      ids: [
        149,
      ],
      weight: 0.36
    },
    {
      ids: [
        330,
      ],
      weight: 0.33
    },
    {
      ids: [
        366,
        370,
      ],
      weight: 0.32
    },
    {
      ids: [
        284,
      ],
      weight: 0.31
    },
    {
      ids: [
        231,
        372,
      ],
      weight: 0.3
    },
    {
      ids: [
        287,
      ],
      weight: 0.29
    },
    {
      ids: [
        204,
        300,
      ],
      weight: 0.27
    },
    {
      ids: [
        279,
        374,
        377,
        402,
      ],
      weight: 0.26
    },
    {
      ids: [
        293,
        369,
        384,
        558,
      ],
      weight: 0.25
    },
    {
      ids: [
        148,
        285,
        407,
      ],
      weight: 0.24
    },
    {
      ids: [
        203,
        205,
        283,
        307,
        557,
      ],
      weight: 0.23
    },
    {
      ids: [
        286,
      ],
      weight: 0.22
    },
    {
      ids: [
        574,
      ],
      weight: 0.2
    },
    {
      ids: [
        274,
      ],
      weight: 0.19
    },
    {
      ids: [
        294,
        403,
        408,
        561,
      ],
      weight: 0.16
    },
    {
      ids: [
        373,
      ],
      weight: 0.15
    },
    {
      ids: [
        202,
        280,
        306,
        428,
      ],
      weight: 0.14
    },
    {
      ids: [
        310,
        411,
      ],
      weight: 0.13
    },
    {
      ids: [
        145,
        150,
        282,
        295,
        319,
        385,
        387,
        390,
        412,
      ],
      weight: 0.12
    },
    {
      ids: [
        144,
        311,
        332,
        362,
        363,
        388,
        404,
        409,
        415,
      ],
      weight: 0.11
    },
    {
      ids: [
        255,
        257,
        258,
        263,
        264,
        281,
        290,
        308,
        312,
        313,
        318,
        365,
        386,
        389,
        391,
        392,
        395,
        405,
        406,
        410,
      ],
      weight: 0.1
    },
    {
      ids: [
        584,
      ],
      weight: 0.09
    },
    {
      ids: [
        364,
      ],
      weight: 0.07
    },
    {
      ids: [
        575,
        583,
      ],
      weight: 0.06
    },
    {
      ids: [
        213,
        517,
        518,
        556,
      ],
      weight: 0.04
    },
    {
      ids: [
        554,
      ],
      weight: 0.03
    },
    {
      ids: [
        570,
      ],
      weight: 0.02
    },
    {
      ids: [
        514,
        515,
        585,
      ],
      weight: 0.01
    },
    {
      ids: [
        242,
        572,
      ],
      weight: 0
    },
  ],
  centerId: 563,
  name: "Arch Medial Height",
  min: 1,
  max: 40,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const archEditorJoint: HighLevelJoint = {
  vertices: [
    {
      ids: [
        497,
        498,
        500,
        501,
        502,
        503,
        504,
        505,
        506,
        507,
        508,
        509,
        510,
        511,
        512,
        513,
        514,
        515,
        516,
        517,
        518,
        519,
        520,
        534,
        535,
        536,
        543,
        544,
        545,
        546,
        547,
        549,
        550,
        553,
        554,
        555,
        556,
        557,
        558,
        561,
        562,
        563,
        570,
        571,
        572,
        573,
        574,
        575,
        576,
        577,
        578,
        579,
        580,
        582,
        583,
        584,
      ],
      weight: 1
    },
    {
      ids: [489, 491, 492, 493, 494, 495, 496, 521, 522, 523, 524, 525, 526, 527,
        528, 529, 530, 531, 532, 533, 537, 540, 542, 559, 560, 581, 586],
      weight: -1
    }
  ],
  centerId: 505,
  name: "Arch Sagital Position",
  min: 50,
  max: 70,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const forefootLateralJoint: HighLevelJoint = {
  vertices: [
    {
      ids: [
        580,
      ],
      weight: 1
    },
    {
      ids: [
        536,
      ],
      weight: 0.96
    },
    {
      ids: [
        505,
      ],
      weight: 0.95
    },
    {
      ids: [
        506,
        581,
      ],
      weight: 0.92
    },
    {
      ids: [
        529,
        532,
      ],
      weight: 0.91
    },
    {
      ids: [
        533,
      ],
      weight: 0.9
    },
    {
      ids: [
        504,
      ],
      weight: 0.7
    },
    {
      ids: [
        530,
        531,
      ],
      weight: 0.66
    },
    {
      ids: [
        507,
      ],
      weight: 0.65
    },
    {
      ids: [
        489,
        492,
      ],
      weight: 0.49
    },
    {
      ids: [
        526,
        586,
      ],
      weight: 0.34
    },
    {
      ids: [
        501,
        525,
      ],
      weight: 0.33
    },
    {
      ids: [
        490,
        491,
      ],
      weight: 0.31
    },
    {
      ids: [
        500,
      ],
      weight: 0.3
    },
    {
      ids: [
        577,
      ],
      weight: 0.16
    },
    {
      ids: [
        576,
      ],
      weight: 0.15
    },
    {
      ids: [
        535,
      ],
      weight: 0.11
    },
    {
      ids: [
        502,
        503,
      ],
      weight: 0.02
    },
    {
      ids: [
        527,
        528,
      ],
      weight: 0.01
    },
    {
      ids: [
        537,
      ],
      weight: 0
    },
  ],
  centerId: 580,
  name: "Forefoot Lateral Wedge",
  min: 0,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const forefootMedialJoint: HighLevelJoint = {
  vertices: [
    {
      ids: [
        516,
      ],
      weight: 1
    },
    {
      ids: [
        519,
      ],
      weight: 0.97
    },
    {
      ids: [
        522,
      ],
      weight: 0.96
    },
    {
      ids: [
        523,
      ],
      weight: 0.95
    },
    {
      ids: [
        521,
      ],
      weight: 0.91
    },
    {
      ids: [
        517,
        524,
      ],
      weight: 0.9
    },
    {
      ids: [
        518,
      ],
      weight: 0.88
    },
    {
      ids: [
        494,
        495,
      ],
      weight: 0.7
    },
    {
      ids: [
        493,
      ],
      weight: 0.54
    },
    {
      ids: [
        496,
      ],
      weight: 0.53
    },
    {
      ids: [
        562,
        579,
      ],
      weight: 0.35
    },
    {
      ids: [
        559,
      ],
      weight: 0.23
    },
    {
      ids: [
        540,
        555,
      ],
      weight: 0.22
    },
    {
      ids: [
        560,
      ],
      weight: 0.21
    },
    {
      ids: [
        539,
        542,
        556,
      ],
      weight: 0.2
    },
    {
      ids: [
        561,
      ],
      weight: 0.09
    },
  ],
  centerId: 519,
  name: "Forefoot Medial Wedge",
  min: 0,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const BandJoints: HighLevelJoint = {
  vertices: [
    {
      ids: [
        202,
        205,
        280,
        281,
        282,
        283,
        284,
        285,
        286,
        287,
        293,
        294,
        295,
        307,
        311,
        312,
        362,
        364,
        365,
        374,
        375,
        388,
        391,
        392,
        396,
        397,
        407,
        410,
        424,
        425,
      ],
      weight: 1
    },
    {
      ids: [
        203,
        204,
        306,
        308,
        310,
        313,
        325,
        363,
        366,
        369,
        372,
        373,
        376,
        378,
        381,
        395,
        405,
        406,
        408,
        409,
        411,
        412,
        415,
      ],
      weight: 0.99
    },
    {
      ids: [
        254,
        324,
        380,
        398,
      ],
      weight: 0.98
    },
    {
      ids: [
        253,
        379,
        404,
      ],
      weight: 0.97
    },
    {
      ids: [
        263,
        264,
        370,
        371,
        393,
        401,
        402,
        403,
      ],
      weight: 0.96
    },
    {
      ids: [
        212,
        269,
        318,
        319,
        332,
        367,
        368,
        377,
        390,
        400,
      ],
      weight: 0.95
    },
    {
      ids: [
        394,
      ],
      weight: 0.94
    },
    {
      ids: [
        389,
      ],
      weight: 0.93
    },
    {
      ids: [
        252,
      ],
      weight: 0.91
    },
    {
      ids: [
        211,
      ],
      weight: 0.9
    },
    {
      ids: [
        316,
      ],
      weight: 0.89
    },
    {
      ids: [
        386,
        399,
      ],
      weight: 0.88
    },
    {
      ids: [
        244,
        258,
        265,
      ],
      weight: 0.87
    },
    {
      ids: [
        246,
        317,
        385,
      ],
      weight: 0.86
    },
    {
      ids: [
        257,
        288,
        289,
        383,
        384,
      ],
      weight: 0.85
    },
    {
      ids: [
        89,
        300,
        382,
      ],
      weight: 0.84
    },
    {
      ids: [
        245,
        297,
      ],
      weight: 0.83
    },
    {
      ids: [
        88,
      ],
      weight: 0.82
    },
    {
      ids: [
        247,
        290,
        387,
      ],
      weight: 0.81
    },
    {
      ids: [
        298,
      ],
      weight: 0.79
    },
    {
      ids: [
        255,
      ],
      weight: 0.71
    },
    {
      ids: [
        210,
      ],
      weight: 0.7
    },
    {
      ids: [
        314,
        329,
      ],
      weight: 0.69
    },
    {
      ids: [
        50,
        301,
      ],
      weight: 0.67
    },
    {
      ids: [
        273,
      ],
      weight: 0.65
    },
    {
      ids: [
        266,
        268,
        270,
        274,
      ],
      weight: 0.64
    },
    {
      ids: [
        271,
        305,
        330,
      ],
      weight: 0.63
    },
    {
      ids: [
        256,
        322,
      ],
      weight: 0.62
    },
    {
      ids: [
        277,
      ],
      weight: 0.61
    },
    {
      ids: [
        276,
        279,
      ],
      weight: 0.6
    },
    {
      ids: [
        206,
      ],
      weight: 0.59
    },
    {
      ids: [
        87,
        417,
      ],
      weight: 0.57
    },
    {
      ids: [
        47,
      ],
      weight: 0.56
    },
    {
      ids: [
        267,
      ],
      weight: 0.55
    },
    {
      ids: [
        171,
        220,
      ],
      weight: 0.54
    },
    {
      ids: [
        170,
      ],
      weight: 0.53
    },
    {
      ids: [
        315,
      ],
      weight: 0.52
    },
    {
      ids: [
        321,
        416,
      ],
      weight: 0.51
    },
    {
      ids: [
        326,
      ],
      weight: 0.49
    },
    {
      ids: [
        272,
      ],
      weight: 0.47
    },
    {
      ids: [
        457,
      ],
      weight: 0.45
    },
    {
      ids: [
        303,
      ],
      weight: 0.42
    },
    {
      ids: [
        158,
      ],
      weight: 0.41
    },
    {
      ids: [
        49,
        302,
        304,
      ],
      weight: 0.39
    },
    {
      ids: [
        331,
      ],
      weight: 0.38
    },
    {
      ids: [
        157,
      ],
      weight: 0.37
    },
    {
      ids: [
        143,
        144,
      ],
      weight: 0.36
    },
    {
      ids: [
        48,
        223,
      ],
      weight: 0.35
    },
    {
      ids: [
        99,
        237,
      ],
      weight: 0.34
    },
    {
      ids: [
        249,
      ],
      weight: 0.33
    },
    {
      ids: [
        231,
        250,
        440,
      ],
      weight: 0.32
    },
    {
      ids: [
        146,
      ],
      weight: 0.3
    },
    {
      ids: [
        275,
      ],
      weight: 0.28
    },
    {
      ids: [
        221,
      ],
      weight: 0.27
    },
    {
      ids: [
        278,
      ],
      weight: 0.26
    },
    {
      ids: [
        222,
      ],
      weight: 0.24
    },
    {
      ids: [
        327,
        437,
      ],
      weight: 0.22
    },
    {
      ids: [
        309,
        333,
        446,
      ],
      weight: 0.2
    },
    {
      ids: [
        98,
        238,
      ],
      weight: 0.19
    },
    {
      ids: [
        299,
        328,
        448,
      ],
      weight: 0.18
    },
    {
      ids: [
        296,
        442,
      ],
      weight: 0.17
    },
    {
      ids: [
        145,
        413,
        441,
        443,
        444,
        445,
        447,
      ],
      weight: 0.15
    },
    {
      ids: [
        92,
        449,
        451,
      ],
      weight: 0.13
    },
    {
      ids: [
        224,
        438,
      ],
      weight: 0.12
    },
    {
      ids: [
        40,
      ],
      weight: 0.11
    },
    {
      ids: [
        218,
        219,
        429,
        439,
      ],
      weight: 0.09
    },
    {
      ids: [
        430,
        431,
      ],
      weight: 0.08
    },
    {
      ids: [
        225,
        227,
      ],
      weight: 0.07
    },
    {
      ids: [
        484,
      ],
      weight: 0.06
    },
    {
      ids: [
        44,
        226,
        432,
      ],
      weight: 0.05
    },
    {
      ids: [
        414,
        426,
        428,
      ],
      weight: 0.04
    },
    {
      ids: [
        4,
        86,
        216,
        450,
      ],
      weight: 0.03
    },
    {
      ids: [
        41,
        239,
        427,
        433,
        436,
      ],
      weight: 0.02
    },
    {
      ids: [
        43,
        240,
        262,
        434,
        452,
        455,
      ],
      weight: 0.01
    },
  ],
  center: new THREE.Vector3(0, 0, 0),
  centerId: 375,
  name: "Band Height",
  min: 0.2,
  max: 0.3,
  value: 77,
  cval: 0,
  bval: 1,
};

export const thicknessJoint: HighLevelJoint = {
  vertices: [
    {
      ids: [
        485,
        486,
        487,
        488,
        489,
        490,
        491,
        492,
        493,
        494,
        495,
        496,
        497,
        498,
        499,
        500,
        501,
        502,
        503,
        504,
        505,
        506,
        507,
        508,
        509,
        510,
        511,
        512,
        513,
        514,
        515,
        516,
        517,
        518,
        519,
        520,
        521,
        522,
        523,
        524,
        525,
        526,
        527,
        528,
        529,
        530,
        531,
        532,
        533,
        534,
        535,
        536,
        537,
        538,
        539,
        540,
        541,
        542,
        543,
        544,
        545,
        546,
        547,
        548,
        549,
        550,
        551,
        552,
        553,
        554,
        555,
        556,
        557,
        558,
        559,
        560,
        561,
        562,
        563,
        564,
        565,
        566,
        567,
        568,
        569,
        570,
        571,
        572,
        574,
        575,
        576,
        577,
        578,
        579,
        580,
        581,
        582,
        583,
        584,
        585,
        586,
      ],
      weight: 1
    }
  ],
  centerId: 502,
  name: "Thickness",
  min: 2.5,
  max: 10,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const outsoleThicknessJoint: HighLevelJoint = {
  vertices: [
    {
      ids: [
        4,
        5,
        6,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        39,
        40,
        41,
        42,
        43,
        44,
        45,
        46,
        47,
        48,
        49,
        50,
        85,
        86,
        87,
        88,
        89,
        92,
        98,
        99,
        100,
        101,
        106,
        107,
        108,
        109,
        112,
        113,
        114,
        115,
        123,
        124,
        125,
        126,
        127,
        128,
        129,
        130,
        131,
        132,
        133,
        134,
        135,
        136,
        137,
        138,
        143,
        144,
        145,
        146,
        148,
        149,
        150,
        151,
        152,
        155,
        156,
        157,
        158,
        159,
        160,
        161,
        168,
        169,
        170,
        171,
        174,
        175,
        187,
        193,
        194,
        195,
        196,
        197,
        202,
        203,
        204,
        205,
        206,
        207,
        208,
        210,
        211,
        212,
        213,
        214,
        215,
        216,
        217,
        218,
        219,
        220,
        221,
        222,
        223,
        224,
        225,
        226,
        227,
        230,
        231,
        232,
        236,
        237,
        238,
        239,
        240,
        241,
        242,
        243,
        244,
        245,
        246,
        247,
        248,
        249,
        250,
        251,
        252,
        253,
        254,
        255,
        256,
        257,
        258,
        259,
        260,
        261,
        262,
        263,
        264,
        265,
        266,
        267,
        268,
        269,
        270,
        271,
        272,
        273,
        274,
        275,
        276,
        277,
        278,
        279,
        280,
        281,
        282,
        283,
        284,
        285,
        286,
        287,
        288,
        289,
        290,
        291,
        292,
        293,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        307,
        308,
        309,
        310,
        311,
        312,
        313,
        314,
        315,
        316,
        317,
        318,
        319,
        320,
        321,
        322,
        323,
        324,
        325,
        326,
        327,
        328,
        329,
        330,
        331,
        332,
        333,
        334,
        335,
        336,
        337,
        338,
        339,
        341,
        342,
        343,
        344,
        345,
        346,
        347,
        348,
        349,
        350,
        351,
        352,
        353,
        354,
        355,
        356,
        357,
        358,
        359,
        360,
        361,
        362,
        363,
        364,
        365,
        366,
        367,
        368,
        369,
        370,
        371,
        372,
        373,
        374,
        375,
        376,
        377,
        378,
        379,
        380,
        381,
        382,
        383,
        384,
        385,
        386,
        387,
        388,
        389,
        390,
        391,
        392,
        393,
        394,
        395,
        396,
        397,
        398,
        399,
        400,
        401,
        402,
        403,
        404,
        405,
        406,
        407,
        408,
        409,
        410,
        411,
        412,
        413,
        414,
        415,
        416,
        417,
        418,
        420,
        421,
        424,
        425,
        426,
        427,
        428,
        429,
        430,
        431,
        432,
        433,
        434,
        435,
        436,
        437,
        438,
        439,
        440,
        441,
        442,
        443,
        444,
        445,
        446,
        447,
        448,
        449,
        450,
        451,
        452,
        453,
        454,
        455,
        456,
        457,
        458,
        459,
        460,
        461,
        462,
        463,
        464,
        465,
        466,
        467,
        468,
        469,
        470,
        471,
        472,
        473,
        474,
        475,
        476,
        477,
        478,
        479,
        480,
        481,
        482,
        483,
        484,
        485,
        486,
        487,
        488,
        489,
        490,
        491,
        492,
        493,
        494,
        495,
        496,
        497,
        498,
        499,
        500,
        501,
        502,
        503,
        504,
        505,
        506,
        507,
        508,
        509,
        510,
        511,
        512,
        513,
        514,
        515,
        516,
        517,
        518,
        519,
        520,
        521,
        522,
        523,
        524,
        525,
        526,
        527,
        528,
        529,
        530,
        531,
        532,
        533,
        534,
        535,
        536,
        537,
        538,
        539,
        540,
        541,
        542,
        543,
        544,
        545,
        546,
        547,
        548,
        549,
        550,
        551,
        552,
        553,
        554,
        555,
        556,
        557,
        558,
        559,
        560,
        561,
        562,
        563,
        564,
        565,
        566,
        567,
        568,
        569,
        570,
        571,
        572,
        573,
        574,
        575,
        576,
        577,
        578,
        579,
        580,
        581,
        582,
        583,
        584,
        585,
        586,
      ],
      weight: 1
    },
  ],
  centerId: 151,
  name: "Outsole Thickness",
  min: 10,
  max: 40,
  value: 0,
  center: new THREE.Vector3(0, 0, 0),
  cval: 0,
  bval: 1,
};

export const sandalV1Config: MeshConfig = {
  joints: {
    profile: [
      P0, P1, P2, P3, P4, P5, P6, P7, P8, P9, P10, P11, P12, P13, P14, P15, P16,
      P17, P18, P19, P20, P21, P22, P23, P24, P25, P26, P27, P28, P29, P30, P31
    ],

    surface: {
      heelHeight: heelHeightJoint,
      heelDepth: heelDepthJoint,
      heelLateralWedge: heelLateralJoint,
      heelMedialWedge: heelMedialJoint,
      archCenterHeight: archCenterJoint,
      archLateralHeight: archLateralJoint,
      archMedialHeight: archMedialJoint,
      archSagitalPosition: archEditorJoint,
      thickness: thicknessJoint,
      forefootLateralWedge: forefootLateralJoint,
      forefootMedialWedge: forefootMedialJoint,
      bandHeight: BandJoints,
      outsoleThickness: outsoleThicknessJoint,
    },
  },

  roofJoints: {
    vertices: [
      {
        ids: [485, 486, 487, 488, 489, 490, 491, 492, 493, 494, 495, 496, 497,
          498, 499, 500, 501, 502, 503, 504, 505, 506, 507, 508, 509, 510, 511,
          512, 513, 514, 515, 516, 517, 518, 519, 520, 521, 522, 523, 524, 525,
          526, 527, 528, 529, 530, 531, 532, 533, 534, 535, 536, 537, 538, 539,
          540, 541, 542, 543, 544, 545, 546, 547, 548, 549, 550, 551, 552, 553,
          554, 555, 556, 557, 558, 559, 560, 561, 562, 563, 564, 565, 566, 567,
          568, 569, 570, 571, 572, 573, 574, 575, 576, 577, 578, 579, 580, 581,
          582, 583, 584, 585, 586,],
        weight: 1
      },
    ],
    centerId: 30,
    name: "RoofJoints",
    min: 0,
    max: 1,
    value: 0,
    center: new THREE.Vector3(0, 0, 0),
    cval: 0,
    bval: 1,
  },

  roofVertices: {
    vertices: [
      {
        ids: [497, 498, 500, 503, 504, 505, 506, 507, 508, 509, 510, 511, 512, 513, 514, 515, 517,
          518, 520, 534, 535, 543, 544, 545, 546, 547, 549, 550, 553, 554, 556, 557, 558, 561, 562,
          563, 570, 571, 572, 573, 574, 575, 576, 577, 578, 579, 582, 583, 584],
        weight: 1
      },
    ],
    centerId: 30,
    name: "RoofVertices",
    min: 0,
    max: 1,
    value: 0,
    center: new THREE.Vector3(0, 0, 0),
    cval: 0,
    bval: 1,
  },

  pressureAlignmentDefault: [549, 502], // first value is Main joint, second value is Rotation joint
  archLineIndices: [505, 506, 500, 502, 555, 519, 516],
  inStepAreaIndices: [277, 367, 306, 257, 440, 535, 513, 557, 563],
  heelFillIndices: [],
  archFillIndeices: [],

  forefootIndex: 538,
  archStartIndex: 580,
  archEditorIndex: 505,
  heelCenterIndex: 549,
  bandStartIndex: 221
}

